<template>
    <div class="horizontal-tab">
        <div class="card card-with-shadow border-0">
            <nav>
                <div class="nav nav-tabs">
                    <a v-for="(tab, index) in filteredTab" :key="index" class="nav-item p-primary"
                        :class="{ 'active': currentIndex == index }" data-toggle="tab" :href="'#' + tab.name + '-' + index"
                        @click.prevent="loadComponent(tab, index)">
                        {{ $t(tab.name) }}
                    </a>
                </div>
            </nav>
            <div class="tab-content p-primary">
                <div class="tab-pane fade show active" :id="componentId">
                    <app-overlay-loader v-if="preLoader" />
                    <div class="content" v-else>
                        <div class="row mb-2">
                            <div class="col-12 col-sm-6">
                                <app-chart class="mb-primary" type="pie-chart" :height="400" :labels="chart.labels"
                                    :data-sets="chart.set" />
                            </div>
                            <div class="col-12 col-sm-3 px-sm-0">
                                <div class="chart-data-list">
                                    <div class="justify-content-center">
                                        <div class="small-line-chart" v-for="(item, index) in allData" :key="index">
                                            <div class="data-group-item" :style="'color:' + item.color">
                                                <div class="row">
                                                    <div class="col-12 d-flex align-items-center">
                                                        <span class="square" :style="'background-color:' + item.color" />
                                                        <span>{{ item.name }}</span>
                                                    </div>
                                                    <div class="col-12">
                                                        <span class="value"><small>{{ numberWithCurrencyMuseum(item.value) }}</small></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 px-sm-0">
                                <div class="chart-data-list d-flex flex-wrap justify-content-start">
                                    <div class="data-group-item">
                                        <span class="value d-flex"><p class="text-muted mr-2">{{ $t(chart.name) }}</p><p>{{ numberWithCurrencyMuseum(chart.sum) }}</p></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">

                                <div class="chart-data-list col-12 d-flex flex-wrap justify-content-center">
                                    <div class="data-group-item">
                                        <span class="value"><span class="font-weight-bold"></span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TabMixin } from './mixins/TabMixin';
import { formatDateToLocal, formatDateTimeToLocal, numberWithCurrencySymbol, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
export default {
    name: "AppTab",
    mixins: [TabMixin],
    data() {
        return {
            formatDateToLocal,
            numberWithCurrencySymbol,
            numberWithCurrencyMuseum,



        }
    },
}
</script>

<style></style>


